import { render, staticRenderFns } from "./MenuEntry.vue?vue&type=template&id=7b78261a&"
var script = {}
import style0 from "./MenuEntry.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "MenuEntry.vue"
export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/menus/common/MenuEntry.vue
// module id = 65
// module chunks = 1